export enum ERROR_TYPE {
    SynTaxError = 'syntax_error'
}